export type PermissionValue = "yes" | "no" | "all";

export interface DynamicPermissionFilter {
  attributeId: number;
  attributeLabel: string;
  value: PermissionValue;
}

export interface PhotoPermissionsFilter {
  permissions: DynamicPermissionFilter[];
  redactedPhoto: PermissionValue;
}

export interface DateRangeFilter {
  startDate: string | null;
  endDate: string | null;
}

export interface SelfieFilter {
  imageUrl: string | null;
}

export interface SearchFilters {
  photoPermissions: PhotoPermissionsFilter;
  dateRange: DateRangeFilter;
  selectedEventIds: number[];
  selectedTagIds: number[];
  selectedPersonIds: number[];
  selfie: SelfieFilter;
}

export const DEFAULT_PERMISSIONS: PhotoPermissionsFilter = {
  permissions: [],
  redactedPhoto: "all"
};

export const DEFAULT_FILTERS: SearchFilters = {
  photoPermissions: DEFAULT_PERMISSIONS,
  dateRange: { startDate: null, endDate: null },
  selectedEventIds: [],
  selectedTagIds: [],
  selectedPersonIds: [],
  selfie: { imageUrl: null }
};

export const hasActiveFilters = (filters: SearchFilters): boolean =>
  filters.selectedEventIds.length > 0 ||
  filters.selectedTagIds.length > 0 ||
  filters.selectedPersonIds.length > 0 ||
  filters.dateRange.startDate !== null ||
  filters.dateRange.endDate !== null ||
  filters.selfie.imageUrl !== null ||
  filters.photoPermissions.permissions.some(p => p.value !== "all") ||
  filters.photoPermissions.redactedPhoto !== "all";
